import { render, staticRenderFns } from "./playMovie.vue?vue&type=template&id=07d13201&scoped=true"
import script from "./playMovie.vue?vue&type=script&lang=js"
export * from "./playMovie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d13201",
  null
  
)

export default component.exports